import {useEffect, useState} from 'react'
import Image from 'next/image'
import styles from '@/components/Header/Header.module.scss'
import HeaderNotificationsList from '@/components/Header/Notifications/HeaderNotificationsList'
import useHeaderNotifications from '@hooks/header/notifications/useHeaderNotifications'
import {
  deleteAllNotifications,
  deleteAllReadNotifications,
  deleteNotification,
  readAllNotification,
  readNotification,
} from '@services/header/notifications'
import {getTitleHeaderNotification} from '@utils/helpers'
import openToastNotification from '@utils/toastNotification'

const NotificationsTab = () => {
  const [notifications, setNotifications] = useState<any[]>([])
  const {loading, headerNotificationsData, refetch, isRecall} =
    useHeaderNotifications({
      SEQ:
        notifications.length > 0
          ? notifications[notifications.length - 1].SEQ
          : '',
    })

  const handleReadNotification = (seq: string) => {
    if (seq) {
      readNotification({seq})
        .then((response) => {
          if (response?.RESULT === 1) {
            const newNotifications = [...notifications]
            const arrLength = newNotifications.length

            for (let i = 0; i < arrLength; i++) {
              if (
                newNotifications[i]?.SEQ.toString() === seq &&
                newNotifications[i]?.READ_FLAG === '0'
              ) {
                newNotifications[i].READ_FLAG = '1'
                break
              }
            }

            setNotifications(newNotifications)
          }
        })
        .catch((error: any) => {
          console.log(error)
        })
    }
  }

  const handleReadAllNotification = (seq: string) => {
    if (seq) {
      readAllNotification({seq})
        .then((response: any) => {
          if (response?.RESULT === 1) {
            const newNotifications = [...notifications]
            newNotifications.forEach((item) => {
              if (item?.READ_FLAG === '0') {
                item.READ_FLAG = '1'
              }

              return item
            })
            setNotifications(newNotifications)
          }
        })
        .catch((error: any) => {
          openToastNotification({
            title:
              'Có lỗi xảy ra, không thể đọc tất cả thông báo. Vui lòng thử lại sau.',
            type: 'error',
          })
          console.log(error)
        })
    }
  }

  const handleDeleteNotification = (seq: string) => {
    if (seq) {
      deleteNotification({seq})
        .then((response: any) => {
          if (response?.RESULT === 1) {
            setNotifications((prevState) =>
              prevState.filter((item) => item?.SEQ.toString() !== seq),
            )
          }
        })
        .catch((error: any) => {
          openToastNotification({
            title:
              'Có lỗi xảy ra, không thể xóa thông báo. Vui lòng thử lại sau.',
            type: 'error',
          })
          console.log(error)
        })
    }
  }

  const handleDeleteAllReadNotifications = (seq: string) => {
    if (seq) {
      deleteAllReadNotifications({seq})
        .then((response: any) => {
          if (response?.RESULT === 1) {
            setNotifications((prevState) =>
              prevState.filter((item) => item?.READ_FLAG === '0'),
            )
          }
        })
        .catch((error: any) => {
          openToastNotification({
            title:
              'Có lỗi xảy ra, không thể xóa thông báo đã đọc. Vui lòng thử lại sau.',
            type: 'error',
          })
          console.log(error)
        })
    }
  }

  const handleDeleteAllNotifications = (seq: string) => {
    if (seq) {
      deleteAllNotifications({seq})
        .then((response: any) => {
          if (response?.RESULT === 1) {
            setNotifications([])
          }
        })
        .catch((error: any) => {
          openToastNotification({
            title:
              'Có lỗi xảy ra, không thể xóa tất cả thông báo. Vui lòng thử lại sau.',
            type: 'error',
          })
          console.log(error)
        })
    }
  }

  useEffect(() => {
    if (headerNotificationsData?.length > 0) {
      setNotifications((prevState) =>
        isRecall
          ? [...getTitleHeaderNotification(headerNotificationsData)]
          : [
              ...prevState,
              ...getTitleHeaderNotification(headerNotificationsData),
            ],
      )
    }
  }, [headerNotificationsData, isRecall])

  return (
    <div className={styles.tabContentWrapper}>
      <div className={styles.tabToolbar}>
        <button
          className={styles.btnReadAll}
          onClick={() => {
            if (notifications.length > 0) {
              handleReadAllNotification(notifications[0]?.SEQ)
            }
          }}
        >
          Đọc tất cả
        </button>
        <button
          onClick={() => {
            if (notifications.length > 0) {
              handleDeleteAllReadNotifications(notifications[0]?.SEQ)
            }
          }}
        >
          Xóa thông báo đã đọc
        </button>
        <button
          onClick={() => {
            if (notifications.length > 0) {
              handleDeleteAllNotifications(notifications[0]?.SEQ)
            }
          }}
        >
          Xóa tất cả
        </button>
        <a
          href="https://noti.onlive.vn/setting"
          target="_blank"
          className={styles.btnSetting}
        >
          <Image src={process.env.NEXT_PUBLIC_PATH_DOMAIN + 'images/icons/header/notifications-setting.svg'} alt="" width={20} height={21}/>
        </a>
      </div>
      <HeaderNotificationsList
        loading={loading}
        notifications={notifications}
        handleReadNotification={handleReadNotification}
        handleDeleteNotification={handleDeleteNotification}
        refetch={refetch}
      />
    </div>
  )
}

export default NotificationsTab
